import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IntegrationsService } from 'src/app/domains/integrations/services/integrations.service';
import { PlatformContactsResponse, ContactsFilter, IntegrationAuthMethod, IntegrationPlatform, Integration, AUTHORIZATION_METHOD_STATUS, AUTHORIZATION_METHOD_TYPE, CRMUserMapping, CRMUserMappings } from 'voxloud-types/dist/models/integrations/index';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'gdp-integration-details-popup',
  templateUrl: './integration-details-popup.component.html',
  styleUrls: ['./integration-details-popup.component.scss']
})
export class IntegrationDetailsPopupComponent implements OnInit {
  public integration: Integration;
  public loading: boolean;
  public loadingContacts: boolean;
  public integrationPlatform: IntegrationPlatform;
  public authMethod: IntegrationAuthMethod;
  public authMethodUI: string;
  public customFieldsUI = [];
  public filters: ContactsFilter;
  public contactsCount: number;
  public webhooks = [];
  public authMethodsType;
  public authCredentials: string;
  public authMethodStatus = {
    [AUTHORIZATION_METHOD_STATUS.ACTIVE]: 'Active',
    [AUTHORIZATION_METHOD_STATUS.PENDING_CREDENTIALS]: 'Pending Credentials',
  };
  public mappings: CRMUserMapping[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private integrationService: IntegrationsService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.authMethodsType = this.integrationService.authMethods;
    this.filters = {
      company_id: this.integration?.company_id,
      size: 100,
      crm_name: null
    }
    this.loading = true;
    this.refactoringCustomFields(this.integration?.custom_fields);
    forkJoin({
      platform: this.integrationService.getPlatformById(this.integration?.platform_id).pipe(catchError(() => { this.loading = false; return of(undefined) } )),
      authMethod: this.shouldCallAuthMethod() ?
        this.integrationService.getAuthMethod(this.integration.id).pipe(catchError(() => of(undefined))) :
        of(undefined),
      mappings: this.isUserMapping ? this.integrationService.getUserMappings(this.integration?.id).pipe(catchError(() => of(undefined))) :
      of(undefined),
    })
    .subscribe((res: {
      platform: IntegrationPlatform,
      authMethod: IntegrationAuthMethod,
      mappings: CRMUserMappings,
    }) => {
      this.integrationPlatform = res.platform;
      this.authMethod = res.authMethod;
      this.authCredentials = this.authMethod?.credentials.api_key;
      this.loading = false;
      this.filters.crm_name = this.integrationPlatform.full_name.toUpperCase().replace('/ /g', '_');
      if(res.mappings){
        this.mappings = res.mappings.user_mappings;
      }
      this.refactoringWebhookSubscriptions();
      this.getContactsCount(this.filters)
    },
    () => {
      this.loading = false;
    });
  }

  shouldCallAuthMethod(): boolean {
    const authorizationMethod = this.integration?.authorization_method;

    return authorizationMethod?.status === AUTHORIZATION_METHOD_STATUS.ACTIVE &&
           (authorizationMethod.authorization_type === AUTHORIZATION_METHOD_TYPE.API_KEY || authorizationMethod.authorization_type === AUTHORIZATION_METHOD_TYPE.BASIC);
  }

  refactoringCustomFields(customFields) {
    this.customFieldsUI = customFields?.map(f => {
      return {name: f.name.replaceAll('_', ' ').toLowerCase(), value: f.value}
    })
  }

  refactoringWebhookSubscriptions() {
    if(!this.integration.webhook_subscriptions) {
      return;
    }

    this.webhooks = this.integration.webhook_subscriptions.map(webhook => ({
      created_at: new Date(+webhook.created_at * 1000),
      webhook_events: webhook.events.map(event => ( ` ${event.subject} ${event.action}`))
    }));
  }

  getContactsCount(filters: ContactsFilter) {
    this.loadingContacts = true;
    this.integrationService.getContactsCount(filters).subscribe((res: PlatformContactsResponse) => {
      this.contactsCount = res.total_elements
      this.loadingContacts = false;
    },
    () => {
      this.loadingContacts = false;
    })
  }

  public get isUserMapping() {
    return this.integration?.custom_fields.some(f => f.name === 'USER_MAPPING');
  }

  isBoolean(value: any): boolean {
    return value === 'true' || value === "false";
  }

  close() {
    this.activeModal.close();
  }
}